import React, { useState, useEffect, useCallback, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { CSVLink } from 'react-csv';
import { debounce } from 'lodash';
import $ from 'jquery';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'select2/dist/css/select2.min.css';
import 'select2/dist/js/select2.min.js';

const FeedbackTable = ({ businessId, token, userbranchData, selectedBranchProp }) => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [selectedBranch, setSelectedBranch] = useState('0');
  const [sortField, setSortField] = useState('invoice_date');
  const [sortOrder, setSortOrder] = useState('desc');
  const isFirstSort = useRef(true);
  const isFirstPage = useRef(true);
  const isFirstRowsPerPage = useRef(true);

  const filters = { fromDate, toDate, branchId: selectedBranch };

  const fetchFeedbacks = useCallback(async (page = 1, search = '', limit = 10, filters = {}, sortFieldParam = sortField, sortOrderParam = sortOrder) => {
    if (!businessId || !token) return;
    setLoading(true);

    try {
      const queryParams = new URLSearchParams({
        page,
        search,
        limit,
        fromDate: filters.fromDate || '',
        toDate: filters.toDate || '',
        branchId: filters.branchId || '0',
        sortField: sortFieldParam,
        sortOrder: sortOrderParam,
      }).toString();

      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/fetch-all-feedbacks/${businessId}?${queryParams}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      setFeedbacks(data.feedbacks || []);
      setTotalRows(data.totalRows || 0);
      setCurrentPage(page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [businessId, token, sortField, sortOrder]);


//  useEffect(() => {
//     if (businessId && token) fetchFeedbacks(1, '', rowsPerPage);
//   }, [businessId, token]);




  const handlePageChange = (page) =>{
    if (isFirstPage.current) {
            isFirstPage.current = false;
            return;
        }
     fetchFeedbacks(page, searchTerm, rowsPerPage, filters);
  }
  const handleSearchChange = (e) => {
    const search = e.target.value;
    setSearchTerm(search);
    debouncedFetch(search);
  };
  const debouncedFetch = debounce((search) => fetchFeedbacks(1, search, rowsPerPage, filters), 1000);
  const handleRowsPerPageChange = (newLimit) => {
     if (isFirstRowsPerPage.current) {
    isFirstRowsPerPage.current = false;
    return;
    }
    
    setRowsPerPage(newLimit);
    fetchFeedbacks(1, searchTerm, newLimit, filters);
  };
  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchFeedbacks(1, searchTerm, rowsPerPage, filters);
  };

  const handleClearDates = () => {
    setFromDate('');
    setToDate('');
    setSelectedBranch('0');
    $('#fromDate').val('');
    $('#toDate').val('');
    $('#branchSelect').val('0').trigger('change');
    fetchFeedbacks(1, '', rowsPerPage, { fromDate: '', toDate: '', branchId: '0' });
  };

  const handleBranchChange = (e) => {
    setSelectedBranch(e.target.value);
  };

  useEffect(() => {
    $('#fromDate').datepicker({ format: 'yyyy-mm-dd', autoclose: true }).on('changeDate', (e) => setFromDate(e.target.value));
    $('#toDate').datepicker({ format: 'yyyy-mm-dd', autoclose: true }).on('changeDate', (e) => setToDate(e.target.value));
  }, []);




useEffect(() => {
    if (selectedBranchProp && selectedBranchProp !== selectedBranch) {
        sessionStorage.setItem('activeSection', 'reviews');
        setSelectedBranch(selectedBranchProp);
    }
    if (!selectedBranchProp) {
        $('#runButton').trigger("click");
    }

    const $branchSelect = $('#branchSelect');
    if ($branchSelect.length && !$branchSelect.data('select2')) {
        $branchSelect.select2();
    }
    const handleBranchChange = (e) => {
        setSelectedBranch(e.target.value);
    };
    $branchSelect.on('change', handleBranchChange);
    if (selectedBranch !== '0') {
        $('#runButton').trigger("click");
    }
    return () => {
        $branchSelect.select2('destroy');
        $branchSelect.off('change', handleBranchChange);
    };

}, [selectedBranch, selectedBranchProp]);



 const getEmoji = (val) => {
  const map = {
    '5': { emoji: '😍', label: 'Very Satisfied' },
    '4': { emoji: '😊', label: 'Satisfied' },
    '3': { emoji: '😐', label: 'Neutral' },
    '2': { emoji: '😕', label: 'Dissatisfied' },
    '1': { emoji: '😡', label: 'Very Dissatisfied' },
    'N/A': { emoji: '', label: 'No Feedback' },
    '': { emoji: '', label: 'No Feedback' },
    null: { emoji: '', label: 'No Feedback' },
    undefined: { emoji: '', label: 'No Feedback' },
  };

  const feedback = map[val] || map['N/A'];
  return <span title={feedback.label}>{feedback.emoji || '❔'}</span>;

};

 const columns = [
  {
    name: 'S.No',
    selector: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
    sortField: 'id',
    sortable: true,
    width: '7%',
  },
  {
    name: 'Branch',
    selector: (row) => row.branch_name || 'N/A',
    sortField: 'branch_name',
    sortable: true,
    wrap: true,
    width: '10%',
  },
  {
    name: 'Invoice',
    selector: (row) => {
      const feedbackLink = `${process.env.REACT_APP_FEEDBACK_URL}/${row.unique_code}`;
      return (
        <a href={feedbackLink} style={{ color: '#81a683', fontWeight: 'bold', textDecoration: 'underline' }} target="_blank" rel="noopener noreferrer">
          {row.invoice_number || 'N/A'}
        </a>
      );
    },
    sortField: 'invoice_number',
    sortable: true,
    wrap: true,
    width: '10%',
  },

  {
    name: 'Customer Name',
    selector: (row) => row.customer_name || 'N/A',
    sortField: 'customer_name',
    sortable: false,
    wrap: true,
    width: '15%',
  },
  {
    name: 'Phone',
    selector: (row) => row.customer_cell || 'N/A',
    sortField: 'customer_cell',
    sortable: false,
    wrap: true,
    width: '15%',
  },
  {
    name: 'Date',
    selector: (row) => row.invoice_date || 'N/A',
    sortField: 'invoice_date',
    sortable: true,
    wrap: true,
    width: '10%',
  },
  {
    name: 'Feedback',
    selector: (row) => (
      <div style={{ fontWeight: 'bold', padding: '10px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Quality of Service</span>
          {getEmoji(row.qos)}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Atmosphere</span>
          {getEmoji(row.atmosphere)}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Experience</span>
          {getEmoji(row.experience)}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Value for Money</span>
          {getEmoji(row.valueformoney)}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Recommendable</span>
          {getEmoji(row.recommendable)}
        </div>
      </div>
    ),
    wrap: true,
    sortable: false,
    width: '20%',
  },


  {
    name: 'Comment',
    selector: (row) => row.comment || 'No comment',
    wrap: true,
    width: '25%',
  },
];


  return (
    <div>
      <div className="col-sm-12 print-hidden">
        <div className="card-box p-0">
          <h4 className="header-title m-t-0 m-b-30">Filters:</h4>
          <form id='filter-form' onSubmit={handleFilterSubmit}>
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-12">
                <label className="control-label">From:</label>
                <input type="text" className="form-control" id="fromDate" placeholder="YYYY-MM-DD" />
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <label className="control-label">To:</label>
                <input type="text" className="form-control" id="toDate" placeholder="YYYY-MM-DD" />
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <label className="control-label">Branch:</label>
                <select id="branchSelect" className="form-control" value={selectedBranch} onChange={handleBranchChange}>
                  <option value="0">All</option>
                  {Array.isArray(userbranchData) ? (
                    userbranchData.map(branch => (
                      <option key={branch.id_branch} value={branch.id_branch}>
                        {branch.branch_name}
                      </option>
                    ))
                  ) : (
                    <option disabled>No branches available</option>
                  )}
                </select>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <label className="control-label" style={{ visibility: 'hidden' }}>Hidden</label>
                <button type="submit" className="btn btn-primary" id="runButton">Run</button>
                <div className="filters-buttons-div" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                  <a href="#" id="clear-btn" onClick={(e) => { e.preventDefault(); handleClearDates(); }}>Clear</a>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className='col-12' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', marginTop: '30px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CSVLink
            data={feedbacks.map((feedback, index) => ({
              'S.No': index + 1,
              'Customer Name': feedback.customer_name,
              'Customer Cell': feedback.customer_cell,
              'Rating': feedback.rating,
              'Review': feedback.feedback,
            }))}
            filename="feedbacks.csv"
            className="btn btn-primary print-hidden"
            style={{ margin: '2px' }}
          >
            CSV
          </CSVLink>
          <button className="btn btn-primary print-hidden" onClick={() => window.print()} style={{ margin: '2px' }}>
            Print
          </button>
        </div>
        <input
          type="text"
          className='form-control print-hidden'
          placeholder="Search..."
          value={searchTerm}
          onChange={handleSearchChange}
          style={{ width: '200px' }}
        />
      </div>

      <div  style={{ overflowX: 'auto' }}>
        <DataTable
          columns={columns}
          data={feedbacks}
          progressPending={loading}
          striped
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          // highlightOnHover
          sortServer
          persistTableHead
          onSort={(column, sortDirection) => {
             if (isFirstSort.current) {
              isFirstSort.current = false;
              return;
              }
          setSortField(column.sortField || column.selector); // Ensure it maps to SQL-safe field
          setSortOrder(sortDirection);
          fetchFeedbacks(currentPage, searchTerm, rowsPerPage, filters, column.sortField || column.selector, sortDirection);
        }}
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
         
        />
      </div>
    </div>
  );
};

export default FeedbackTable;
